// extracted by mini-css-extract-plugin
export default {"container":"Component_container__MYq94","container2":"Component_container2__4uXJs","active":"Component_active__MOwFh","default":"Component_default__KcHeL"};